const variables = {
  mainNavigationLargeHeight: 128,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'ghost',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 0,
  mainNavigationSmallMenuButtonPosition: 'end',
  mainNavigationSmallProfileMenuButtonVariant: 'ghost',
};

export default variables;
